'use strict';

export class Endpoint {
	constructor() {
		this.wp_nonce_ = wp_nonce_;
	}
	async fetch( endpoint ) {

		try {
			const headers = new Headers({
				'X-WP-Nonce': this.wp_nonce_
			});
			const response = await fetch(
				window.location.origin + endpoint,
				{
					headers:headers
				}
			);
			if ( ! response.ok ) {
				throw new Error(
					'Cannot get data from ' +
					window.location.origin +
					endpoint
				);
			}

			return response.json();
		} catch ( error ) {
			console.error( error.message );
		}
	}
}
